import { render } from "./AccordionTab.vue?vue&type=template&id=107e2450"
import script from "./AccordionTab.vue?vue&type=script&lang=js"
export * from "./AccordionTab.vue?vue&type=script&lang=js"
script.render = render

export default script